import { render, staticRenderFns } from "./ForgotPasswordCard.vue?vue&type=template&id=2c95c494&scoped=true"
import script from "./ForgotPasswordCard.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordCard.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPasswordCard.vue?vue&type=style&index=0&id=2c95c494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c95c494",
  null
  
)

export default component.exports